import { FeaturedCardType, IPaginationResponseDto, IFeaturedCard, IFeaturedCardSet, IFeaturedCardSetRequestDtoWithVerifies } from '../types';
import { AxiosResponse, Canceler } from 'axios';
import settings from '../settings';
import api from './base';

export function getFeaturedCards(
  type: FeaturedCardType | undefined,
  searchKey: string,
  page = 1,
  limit = 20,
): [Promise<AxiosResponse<IPaginationResponseDto<IFeaturedCard>>>, Canceler] {
  const uri = `${settings.getApiURI()}/home-admin/v1/featured-cards`;

  return api.getWithCancel(uri, {
    params: {
      type,
      searchKey,
      page,
      limit,
    },
  });
}
export function getFeaturedCardSets(page = 1, limit = 20): [Promise<AxiosResponse<IPaginationResponseDto<IFeaturedCardSet>>>, Canceler] {
  const uri = `${settings.getApiURI()}/homeset/v1/featuredcards`;

  return api.getWithCancel(uri, {
    params: {
      page,
      limit,
    },
  });
}

export function deleteFeaturedCard(id: number) {
  const uri = `${settings.getApiURI()}/home-admin/v1/featured-cards/${id}`;

  return api.http.delete(uri);
}
export function deleteFeaturedCardSet(setId: string) {
  const uri = `${settings.getApiURI()}/homeset/v1/featuredcards/${setId}`;

  return api.http.delete(uri);
}

export function getLiveFeaturedCardSets() {
  const uri = `${settings.getApiURI()}/homeset/v1/featuredcards`;

  return api.getWithCancel(uri, {
    params: {
      isLive: true,
    },
  });
}

export function searchFeaturedCardSetByTitle(keyword: string): Promise<AxiosResponse<IFeaturedCardSet[]>> {
  const uri = `${settings.getApiURI()}/homeset/v1/featuredcards/search`;

  return api.http.get(uri, {
    params: {
      keyword,
    },
  });
}

export function createFeaturedCard(payload: Partial<IFeaturedCard>): Promise<AxiosResponse<IFeaturedCard>> {
  const uri = `${settings.getApiURI()}/home-admin/v1/featured-cards`;

  return api.http.post(uri, payload);
}

export function updateFeaturedCard(id: number, payload: IFeaturedCard): Promise<AxiosResponse<IFeaturedCard>> {
  const uri = `${settings.getApiURI()}/home-admin/v1/featured-cards/${id}`;

  return api.http.put(uri, payload);
}

export function createFeaturedCards(payload: IFeaturedCardSet | Partial<IFeaturedCardSet>): Promise<AxiosResponse<IFeaturedCardSet>> {
  const uri = `${settings.getApiURI()}/homeset/v1/featuredcards`;

  return api.http.post(uri, payload);
}

export function duplicateFeaturedCardSet(id: number) {
  const uri = `${settings.getApiURI()}/homeset/v1/featuredcards/duplicate`;

  return api.http.post(uri, {
    id,
  });
}

export function getFeaturedCardSet(trackingId: string): [Promise<AxiosResponse<IFeaturedCardSet>>, Canceler] {
  const uri = `${settings.getApiURI()}/homeset/v1/featuredcards/${trackingId}`;

  return api.getWithCancel(uri);
}

export function getFeaturedCard(id: number): [Promise<AxiosResponse<IFeaturedCard>>, Canceler] {
  const uri = `${settings.getApiURI()}/homeset/v1/featuredcards/${id}`;

  return api.getWithCancel(uri);
}

export function editFeaturedCardSets(payload: IFeaturedCardSetRequestDtoWithVerifies): Promise<AxiosResponse<IFeaturedCardSet[]>> {
  const uri = `${settings.getApiURI()}/homeset/v1/featuredcards`;

  return api.http.put(uri, payload);
}
